"use strict";

exports.__esModule = true;

exports.default = function (string, suffix) {
  return string.substr(-suffix.length) === suffix;
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/polished/lib/internalHelpers/_endsWith.js
// module id = 1136
// module chunks = 168707334958949